import { SVGProps, Ref, forwardRef } from 'react';

export const ZarplataGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11" fill="#919191" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.687 16.814v-1.88a.376.376 0 0 1 .524-.345c1.156.502 2.424.746 3.804.746 1.89 0 2.985-.522 2.985-1.443 0-.82-.721-1.219-2.189-1.219H9.754a.38.38 0 0 1-.38-.38v-1.776c0-.21.17-.38.38-.38h2.057c1.194 0 1.791-.373 1.791-1.095q0-1.194-2.537-1.194c-1.3 0-2.475.202-3.52.62a.373.373 0 0 1-.51-.349V6.327a.57.57 0 0 1 .361-.527c1.21-.492 2.702-.738 4.44-.738q2.277 0 3.806.97c1.02.646 1.541 1.468 1.541 2.438 0 1.27-.514 2.132-1.543 2.568-.078.033-.075.149.005.18 1.169.445 2.036 1.41 2.036 2.873q0 1.754-1.716 2.91c-1.119.747-2.611 1.12-4.452 1.12-1.788 0-3.267-.268-4.474-.785a.57.57 0 0 1-.352-.522"
            fill="#E2E2E2"
        />
    </svg>
));
ZarplataGrayscaleSize24Glyph.displayName = 'ZarplataGrayscaleSize24Glyph';
